import { Link, LinkProps } from "@mui/material";
import { forwardRef } from "react";
import { Link as ReactLink, LinkProps as ReactLinkProps } from "react-router";

export const RoutingLink = forwardRef((props: LinkProps & ReactLinkProps, ref) => (
  <Link ref={ref} component={ReactLink} discover="render" color="inherit" sx={{ textDecoration: "none" }} {...props}>
    {props.children}
  </Link>
));
